import { Get_SMS_Permission } from "@/modules/crm/leads/graphql-queries";
import Lead_signalr from "@/modules/crm/leads/signalr-constants";
import UseGql from "@/services/graph-ql/useGql";
import OnInitHub from "@/services/signal-R/on-receive-hook";
import useSignalRClient from "@/services/signal-R/signalr-hubs";
import { success } from "@/services/variables";
import { setEnableSMSForNonOptedLeadsToState } from "@/store/slices/general/generalSlice";
import { getAllRequests } from "@/store/slices/requests";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const {
  hubName,
  InvokeMethodNames: { smsConsentSetting },
  onReceiveMethodNames: { onSmsConsentSettingResponse },
} = Lead_signalr;
const resultMethods = {
  [onSmsConsentSettingResponse]: { successOperation: "saved" },
};

const useManageSMSPermission = (config = { showStatus: false }) => {
  const { statuses, RTC } = useSignalRClient({ hubName: hubName });
  const leadHub = RTC[hubName];
  const requests = useSelector(getAllRequests);
  const { clearStateByMethods } = OnInitHub();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const methodKeys = Object.keys(resultMethods);
  useEffect(() => {
    if (config.showStatus) {
      handleResponse(methodKeys, resultMethods);
    }
  }, [requests[onSmsConsentSettingResponse]]);

  const handleResponse = (methodKeys, resultMethods) => {
    let findedKey = methodKeys.find((key) => key in requests && requests[key]);
    if (findedKey) {
      let response = requests[findedKey];
      let successOperation = resultMethods[findedKey]?.successOperation;
      responseHandler(response, successOperation, findedKey);
      clearStateByMethods(methodKeys);
    }
  };

  const responseHandler = (response, successOperation = "", methodName) => {
    setLoading(false);
    if (response.isSuccess) {
      onSuccess(successOperation);
    } else {
      let msg = response?.errors?.[0] || "Something went wrong";
      onError(msg);
    }
  };

  const onSuccess = (operation, refetch = false) => {
    toast.success(success.saveSuccess("Permission", operation));
    getSMSPermission();
  };

  const onError = (errorMsg) => {
    toast.error(toastMsg.errors.customError(errorMsg));
  };

  const handleSMSPermission = (payload) => {
    if (statuses[hubName] && leadHub) {
      let methodName = smsConsentSetting;
      setLoading(true);
      leadHub.invoke(methodName, payload).then((res) => {
        console.log("on sms permission callback", res);
      });
    }
  };

  const [smsDisabled, setSmsDisabled] = useState(true);
  const [loadingConsent, setLoadingConsent] = useState(true);

  const getSMSPermissionGQL = UseGql(Get_SMS_Permission);
  const getSMSPermission = async () => {
    try {
      return getSMSPermissionGQL.executeQuery().then((data) => {
        const response = data?.data;
        if (response?.generalSettings?.length) {
          const res = response.generalSettings.find((item) =>
            Object.keys(item ?? {}).includes("enableSMSForNonOptedLeads")
          );
          setSmsDisabled(res?.enableSMSForNonOptedLeads);
          dispatch(
            setEnableSMSForNonOptedLeadsToState(res?.enableSMSForNonOptedLeads)
          );
          setLoadingConsent(false);
          return res?.enableSMSForNonOptedLeads;
        } else {
          setSmsDisabled(true);
          dispatch(setEnableSMSForNonOptedLeadsToState(true));
          setLoadingConsent(false);
        }
      });
    } catch (error) {
      console.error("Fetch general settings error::", error);
      setLoadingConsent(false);
    }
  };

  return {
    handleSMSPermission,
    loading,
    getSMSPermission,
    smsDisabled,
    loadingConsent,
  };
};
export default useManageSMSPermission;
